<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import ConfettiCanvas from 'canvas-confetti';
  import Track from '@utils/track';

  const dispatch = createEventDispatcher();

  let showConfetti = () => {
    ConfettiCanvas({ particleCount: 200, spread: 360 });
  };

  let handleStartAdding = () => {
    Track.addFirstRecNext();
    dispatch('finished');
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .invite-flow-welcome-container {
    margin: -30px;
    margin-top: -50px;
  }

  .invite-flow-banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-bottom: 32px;
  }

  .invite-flow-welcome-modal-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
  }

  .invite-flow-welcome-modal-title {
    font-size: 42px;
    line-height: 38px;
    font-weight: 800;
    margin-bottom: 16px;
    text-transform: uppercase;
    color: #717171;
  }

  .invite-flow-welcome-modal-subtitle {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 32px;
    text-align: center;
    color: #7f7f7f;
  }
</style> 

<div class="invite-flow-welcome-container">
  <img src="/images/app-invites/invite-flow-brands-banner.png" class="invite-flow-banner-image" />
  <div class="invite-flow-welcome-modal-content" use:showConfetti>
    <div class="invite-flow-welcome-modal-title national-2-narrow">Add your first recs</div>
    <div class="invite-flow-welcome-modal-subtitle">Start earning commissions.</div>
    <Button
      style="max-width: 300px;"
      text="Start adding"
      on:click={handleStartAdding} />
  </div>
</div>